import { SizesConfig, ButtonSizes } from './Button.types';

export const DARK_VARIANTS = {
  primary: {
    box: {
      variant: 'gradient',
    },
    boxActive: {
      variant: 'gradient',
      gradient: 'accentBackgroundHover',
    },
    text: {
      color: 'accentSurfacePrimary',
    },
    icon: {
      color: 'accentSurfacePrimary',
    },
  },
  secondary: {
    box: {
      variant: 'outline-gradient',
    },
    boxActive: {},
    text: {
      gradient: 'darkSurfaceAccent',
    },
    icon: {
      gradient: 'accentBackground',
    },
  },
  tertiary: {
    box: {},
    boxActive: {},
    text: {
      color: 'darkSurfacePrimary',
    },
    icon: {
      color: 'darkSurfacePrimary',
    },
  },
} as const;

export const LIGHT_VARIANTS = {
  primary: {
    box: {
      backgroundColor: 'primaryBackground',
    },
    boxActive: {
      backgroundColor: 'primaryBackgroundHover',
    },
    text: {
      gradient: 'darkSurfaceAccent',
    },
    icon: {
      gradient: 'accentBackground',
    },
  },
  secondary: {
    box: {
      borderColor: 'borderPrimary',
      borderWidth: 'border-width-025',
    },
    boxActive: {},
    text: {
      color: 'accentSurfacePrimary',
    },
    icon: {
      color: 'accentSurfacePrimary',
    },
  },
  tertiary: {
    box: {},
    boxActive: {},
    text: {
      color: 'accentSurfacePrimary',
    },
    icon: {
      color: 'accentSurfacePrimary',
    },
  },
} as const;

export const SIZES: SizesConfig = {
  [ButtonSizes.inline]: {
    paddingHorizontal: 'space-600',
  },
  [ButtonSizes.small]: {
    height: 40,
    paddingHorizontal: 'space-300',
    gap: 'space-100',
  },
  [ButtonSizes.large]: {
    height: 56,
    paddingHorizontal: 'space-600',
    gap: 'space-200',
  },
};

export const ICON_ONLY_SIZES: SizesConfig = {
  [ButtonSizes.inline]: {},
  [ButtonSizes.small]: {
    width: 40,
    height: 40,
  },
  [ButtonSizes.large]: {
    width: 56,
    height: 56,
  },
};

export const DISABLED_BUTTON_OPACITY = 0.36;
